import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FirebaseContext } from "../contexts/FirebaseContext";
import TopBar from "./TopBar";
import { ReactComponent as DoneIcon } from "../assets/icon_done.svg";
import { ReactComponent as BackIcon } from "../assets/icon_back.svg";

const BACK_FILTER =
  "brightness(0) saturate(100%) invert(19%) sepia(7%) saturate(1119%) hue-rotate(180deg) brightness(90%) contrast(94%)";
const DONE_FILTER =
  "brightness(0) saturate(100%) invert(44%) sepia(73%) saturate(2801%) hue-rotate(96deg) brightness(99%) contrast(101%)"; // green
const NOT_DONE_FILTER =
  "brightness(0) saturate(100%) invert(80%) sepia(3%) saturate(0%) hue-rotate(30deg) brightness(95%) contrast(80%)"; // gray

// Top bar for the task detail screen: a back arrow on the left and a
// done/undone toggle on the right (green when the task is already done).
const TaskDetailTopBar = ({ task, title }) => {
  const { updateTask, setTaskTrackingState, completeTask } =
    useContext(FirebaseContext);
  const navigate = useNavigate();
  const isDone = task.taskState === "task_state_done";

  const handleDoneClick = async () => {
    if (isDone) {
      await updateTask(task.id, { taskState: "task_state_backlog" });
    } else {
      if (task.trackStartedTimestamp) {
        await setTaskTrackingState(task.id, task.projectId, false);
      }
      await completeTask(task);
      navigate(-1);
    }
  };

  const iconButton = { background: "none", border: "none", cursor: "pointer" };
  const iconSize = { width: "24px", height: "24px" };

  return (
    <TopBar
      centerContainer={
        <span style={{ fontWeight: 600, color: "var(--text)" }}>{title}</span>
      }
      leftContainer={
        <button onClick={() => navigate(-1)} style={iconButton}>
          <BackIcon style={{ ...iconSize, filter: BACK_FILTER }} />
        </button>
      }
      rightContainer={
        <button onClick={handleDoneClick} style={iconButton}>
          <DoneIcon
            style={{ ...iconSize, filter: isDone ? DONE_FILTER : NOT_DONE_FILTER }}
          />
        </button>
      }
    />
  );
};

export default TaskDetailTopBar;
